import EN from './files/en'
import DK from './files/dk'
import SE from './files/se'
import FI from './files/fi'
import NO from './files/no'

export default {
  en: EN,
  dk: DK,
  se: SE,
  fi: FI,
  no: NO
}
